import ProblematicFtdsFilter from "./ProblematicFtdsFilter"
import ProblematicFtdsItem from "./ProblematicFtdsItem"

const ProblematicFtds = () => {
  return (
    <>
      <ProblematicFtdsFilter/>
      <ProblematicFtdsItem/>
    </>
  )
}

export default ProblematicFtds